import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-466a442a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    ref: "container",
    class: "h-96"
  }, [
    _createVNode(_Transition, {
      name: "loading",
      mode: "in-out",
      tag: "div",
      appear: ""
    }, {
      default: _withCtx(() => [
        (_ctx.hasReachLoading)
          ? _renderSlot(_ctx.$slots, "loading", { key: 0 }, undefined, true)
          : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    _renderSlot(_ctx.$slots, "endReached", {}, undefined, true)
  ], 8, _hoisted_1))
}